import React from 'react';

const testimonials = [
  {
    name: 'Akshay Asok',
    points: '21 points',
    avatar: '/images/Testimonial/Image1.png',
    stars: 5,
    time: 'a month ago',
    content: `Context :
I have been doing the Full stack Developer course at Crio.do. The course is in progress and 6 sprints have been completed.

Update :
There are still 7 sprints and placement remaining. Once they are completed, this review shall be updated with respect to the same.

Review : 5 stars
The classes and presentations are well structured.
The instructors are knowledgeable and pace themselves according to the needs of the class and clear queries satisfactorily.
I find myself looking forward to the next sprints and also to the new future job to which I am guided by this esteemed facility and its instructors.
Hope to see the same quality in further sprints and the placement.`,
  },
  {
    name: 'Shravan Singh',
    points: '62 points',
    avatar: '/images/Testimonial/Image2.png',
    stars: 4,
    time: 'a day ago',
    content: `The faculty is very helpful. When you need technical professionals most, they are always available. The placement team is excellent as well. They provide us with appropriate guidance to improve our placement.`,
  },
  {
    name: 'Vinay Pandey',
    points: '26 points',
    avatar: '/images/Testimonial/Image5.png',
    stars: 5,
    time: 'a month ago',
    content: `My experience with Crio.do has been nothing short of transformative. The hands-on, project-based learning approach helped me build a strong portfolio and gain real-world experience. With the support of dedicated mentors and a structured curriculum, I was able to grasp both front-end and back-end technologies effectively. The job placement support was excellent, and thanks to Crio, I was successfully placed as a Full Stack Engineer. I highly recommend Crio.do to anyone looking to boost their coding skills and kickstart their tech career.`,
  },
  {
    name: 'Suraj Nayak',
    points: '21 points',
    avatar: '/images/Testimonial/Image4.png',
    stars: 5,
    time: 'a month ago',
    content: `Crio is an educational institution that specializes in teaching web development and app development. As a former student, I can attest to the effectiveness of their learning by doing approach. The curriculum is designed to be hands-on, allowing students to build real-world projects that showcase their skills. This approach not only solidified my understanding of the concepts but also helped me build a strong portfolio that impressed potential employers. Thanks to Crio's comprehensive training and career support, I was able to land a job in the tech industry shortly after completing the program.`,
  },
  {
    name: 'Nawaz Siddiqui',
    points: '70 points',
    avatar: '/images/Testimonial/Image6.png',
    stars: 5,
    time: 'a month ago',
    content: `Crio has helped me a lot in my journey from studying to getting placed I have come a long way. Thanks to the amazing mentors and the whole team.`,
  },
];

const StarRating = ({ count = 5 }) => (
  <div className="flex text-sm text-yellow-400">
    {Array.from({ length: 5 }).map((_, idx) => (
      <span key={idx}>{idx < count ? '★' : '☆'}</span>
    ))}
  </div>
);

const TestimonialSection = () => {
  return (
    <div className="bg-gray-50 px-6 py-14 lg:px-12">
      <h2 className="mb-12 text-center font-manrope text-[28px] font-extrabold leading-tight text-gray-800 md:text-[44px] md:leading-[60px]">
        What Our Learners Say
      </h2>

      {/* Masonry Layout */}
      <div className="columns-1 gap-6 md:columns-2 md:px-[100px] xl:columns-3">
        {testimonials.map((t, i) => (
          <div
            key={i}
            className="mb-6 break-inside-avoid rounded-2xl border border-gray-200 bg-white p-6 shadow-md transition-all hover:shadow-lg"
          >
            <div className="mb-4 flex items-start justify-between">
              <div className="flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="h-[40px] w-[40px] rounded-full object-cover"
                />
                <div>
                  <h4 className="text-sm font-semibold text-gray-800">
                    {t.name}
                  </h4>
                  <p className="text-xs text-gray-400">{t.points}</p>
                </div>
              </div>
              <img
                src="/images/GoogleIcon.png"
                alt="google-icon"
                className="h-5 w-5"
              />
            </div>

            <div className="mb-4 flex items-center gap-2">
              <StarRating count={t.stars} />
              <span className="text-xs text-gray-500">{t.time}</span>
            </div>

            <p className="whitespace-pre-line text-sm leading-relaxed text-gray-700">
              {t.content}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestimonialSection;
